interface IProps {
    className?: string;
    color?: string;
    size?: string;
}

/**
 * Stroke-based, so it follows the inherited `color` instead of the `fill` the @pg-design icons use.
 * `color` is a presentation attribute, so a parent stylesheet still overrides it (hover, active).
 */
export const RegionIcon = ({className, color = "#fff", size = "2.4"}: IProps) => (
    <svg
        className={className}
        color={color}
        width={`${size}rem`}
        height={`${size}rem`}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3.5 6.5V3.5H6.5" />
            <path d="M17.5 3.5H20.5V6.5" />
            <path d="M3.5 17.5V20.5H6.5" />
            <path d="M9.5 3.5H14.5" />
            <path d="M3.5 9.5V14.5" />
            <path d="M20.5 9.5V13" />
            <path d="M9.5 20.5H13" />
            <circle cx="16.6" cy="16.6" r="3.3" />
            <path d="M19 19L21.7 21.7" />
        </g>
    </svg>
);
